<template>
    <div class="page">

    </div>
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user'

export default {
    data() {
        return {
            isDialogShow: false,
            phoneList: '',


        }
    },
    methods: {

    },
    mounted() {

    },
    created() {
        if (this.$route.query.iccid) {
            wxRequest("sim/get/invent/url", { iccid: this.$route.query.iccid }, "post").then(
                (res) => {
                    if (res.data.code == 200) {
                        window.location.href = res.data.data;
                    } else {
                        Dialog.alert({ title: '提示', message: '卡板链接未设置！请联系客服处理！' });
                    }
                }
            );

        } else {
            Dialog.alert({ title: '提示', message: '链接参数缺失！请联系客服处理！' });
        }

    }




}
</script>

<style scoped lang="less"></style>